import type { ReactNode } from 'react';
import { ApiError } from '../api/client';

export function Loading() {
  return <div className="muted" style={{ padding: 24 }}>Caricamento…</div>;
}

export function ErrorState({ error }: { error: unknown }) {
  const status = error instanceof ApiError ? error.status : undefined;
  if (status === 403) {
    return <div className="muted" style={{ padding: 24 }}>Accesso riservato — non hai i permessi per questa sezione.</div>;
  }
  return (
    <div style={{ padding: 24, color: 'var(--danger, #c0392b)' }}>
      Errore nel caricamento: {error instanceof Error ? error.message : String(error)}
    </div>
  );
}

export function EmptyState({ title, hint }: { title: string; hint?: string }) {
  return (
    <div className="card empty-state" style={{ padding: 24, margin: 24 }}>
      <h2 className="h2" style={{ marginBottom: 6 }}>{title}</h2>
      {hint && <p className="muted" style={{ margin: 0 }}>{hint}</p>}
    </div>
  );
}

export function Pill({ tone = 'neutral', children }: { tone?: string; children: ReactNode }) {
  return <span className={`pill pill--${tone}`}>{children}</span>;
}

/** Renders an async query state, then `children` with the resolved data. */
export function Query<T>({
  query,
  empty,
  children,
}: {
  query: { isLoading: boolean; isError: boolean; error: unknown; data?: T };
  empty?: { test: (d: T) => boolean; title: string; hint?: string };
  children: (data: T) => ReactNode;
}) {
  if (query.isLoading) return <Loading />;
  if (query.isError) return <ErrorState error={query.error} />;
  const data = query.data as T;
  if (empty && empty.test(data)) return <EmptyState title={empty.title} hint={empty.hint} />;
  return <>{children(data)}</>;
}

export const fmtDate = (iso: string | null) =>
  iso ? new Date(iso).toLocaleDateString('it-IT', { day: '2-digit', month: 'short', year: 'numeric' }) : '—';

export const fmtMoney = (v: string | number | null) =>
  v == null ? '—' : new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR' }).format(Number(v));
